import * as moment from 'moment';

export class Session {

  clientName: string;
  clientVersion: string;
  createdAt: moment.Moment;
  deviceName: string;
  deviceType: string;
  ipAddress: string;
  osName: string;
  osVersion: string;
  updatedAt: moment.Moment;

  public constructor(init?:Partial<Session>) {
    Object.assign(this, init);
  }

  static fromRecord(record) {
    return new Session({
      clientName: record.client_name,
      clientVersion: record.client_version,
      createdAt: moment(record.created_at),
      deviceName: record.device_name,
      deviceType: record.device_type,
      ipAddress: record.ip_address,
      osName: record.os_name,
      osVersion: record.os_version,
      updatedAt: moment(record.updated_at)
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/auth/session.model.ts